import Vue from "vue";
import functionlist from "./FunctionList.vue";

export function load() {
  const selector = "FunctionList-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(functionlist, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
